import ace from 'ace-builds';
import { createCombinedRegexPattern } from './regexUtils';
import { IAceEditor } from 'react-ace/lib/types';

export const refreshHighlightRules = (editor: IAceEditor, activeTexts: string[]) => {
  const session = editor.getSession();
  const TextHighlightRules = ace.require('ace/mode/text_highlight_rules').TextHighlightRules;

  // Define custom highlight rules
  const CustomHighlightRules = function () {
    const regex = createCombinedRegexPattern(activeTexts);

    this.$rules = {
      start: [
        {
          token: 'autocomplete-highlight',
          regex: regex,
        },
      ],
    };
  };
  CustomHighlightRules.prototype = Object.create(TextHighlightRules.prototype);

  // Create and set custom mode
  const TextMode = ace.require('ace/mode/text').Mode;
  const customMode = new TextMode();
  customMode.HighlightRules = CustomHighlightRules;
  session.setMode(customMode);

  // Force re-tokenization
  // (session as any).bgTokenizer.start(0);
};
